<template>
    <v-container v-if="show" fluid class="no-indentation">
        <v-row class="no-indentation mt-2 mr-2">
            <v-col col="11" lg="8" md="10" sm="10" class="pl-2 contentDoc">
                <p>{{ contentComputed }}</p>
            </v-col>
            <v-col col="1" lg="4" md="2" sm="2" class="contentDoc">
                <a :href=hrefComputed class="contentDocView" target="_blank">{{ $t('message.linkView') }}</a>
            </v-col>
        </v-row>
      <div v-if="isAuth">
        <v-btn v-if="this.changeData" @click="pushChangeContent">Изменить</v-btn>
        <v-btn v-if="this.changeData && this.addedData" @click="deleteAddedContent">Удалить</v-btn>
        <v-btn v-if="this.changeData && this.hiddenData && !this.addedData" @click="showContent">Показать</v-btn>
        <v-btn v-if="this.changeData && !this.hiddenData && !this.addedData" @click="hideContent">Спрятать</v-btn>
      </div>
    </v-container>
</template>
<script>
export default {
  props: ['content',
    'href',
    'id_content',
    'id_href',
    'added',
    'change',
    'hidden'
  ],
  name: 'ContentText',
  data () {
    let addedData = this.added !== undefined ? this.added : false
    let changeData = this.change !== undefined ? this.change : true
    let hiddenData = this.hidden !== undefined ? this.hidden : false
    let id_list = []
    if (this.id_href) {
      id_list.push(this.id_href)
    }
    if (this.id_content) {
      id_list.push(this.id_content)
    }
    let _href = this.valueDict(this.href, this.id_href)
    let _content = this.getT18nData(this.content, this.id_content)
    let letThis = this
    new Promise(function (resolve, reject) {
      letThis.$store.dispatch('contentChanges/GET_CONTENT', { 'id_list': id_list })
        .then(() => {
          let content = letThis.$store.getters['contentChanges/content']
          for (let cont_item of content) {
            if (cont_item['id_content'] === parseInt(letThis.id_href)) {
              _href['value_rus'] = cont_item['value_rus']
              _href['value_eng'] = cont_item['value_eng']
              if (cont_item['file']) { _href['file'] = cont_item['file'] }
            }
            if (cont_item['id_content'] === parseInt(letThis.id_content)) {
              _content['value_rus'] = cont_item['value_rus']
              _content['value_eng'] = cont_item['value_eng']
            }
          }
          letThis.checkContent = true
        })
    })
    return {
      checkContent: false,
      deleted: false,
      addedData: addedData,
      changeData: changeData,
      hiddenData: hiddenData,
      hrefData: _href,
      contentData: _content
    }
  },
  methods: {
    getT18nData (i18n_data, id_content) {
      let ru_value = Object.entries(this.$i18n.messages['ru']['message']).filter(value => value[1] == i18n_data)
      if (ru_value.length != 0) {
        return { 'value_rus': this.$i18n.messages['ru']['message'][ru_value[0][0]],
          'value_eng': this.$i18n.messages['en-US']['message'][ru_value[0][0]],
          'id_content': id_content
        }
      }
      let eng_value = Object.entries(this.$i18n.messages['en-US']['message']).filter(value => value[1] == i18n_data)
      if (eng_value.length != 0) {
        return { 'value_rus': this.$i18n.messages['ru']['message'][eng_value[0][0]],
          'value_eng': this.$i18n.messages['en-US']['message'][eng_value[0][0]],
          'id_content': id_content
        }
      }
      return { 'value_rus': i18n_data, 'value_eng': i18n_data, 'id_content': id_content }
    },
    valueDict (value, id_content) {
      return { 'value_rus': value,
        'value_eng': value,
        'file': value,
        'id_content': id_content }
    },
    pushChangeContent () {
      let content_to_change = { 'href': this.hrefData,
        'content': this.contentData
      }
      this.$store.dispatch('contentChanges/SET_CONTENT_TO_CHANGE', {
        'type_to_change': 'ContentDocuments',
        'content_to_change': content_to_change
      })
      this.$router.push('/change_content')
    },
    deleteAddedContent () {
      this.$store.dispatch('contentChanges/DELETE_ADDED_CONTENT', {
        'id_list': [this.id_href, this.id_content]
      })
      this.deleted = true
    },
    showContent () {
      this.$store.dispatch('contentChanges/SHOW_CHANGED_CONTENT', {
        'id_list': [this.id_href, this.id_content]
      })
      this.hiddenData = false
    },
    hideContent () {
      this.$store.dispatch('contentChanges/HIDE_CHANGED_CONTENT', {
        'id_list': [this.id_href, this.id_content]
      })
      this.hiddenData = true
    }
  },
  computed: {
    hrefComputed () {
      if (!this.changeData) {
        if (File.prototype.isPrototypeOf(this.href)) {
          this.hrefData['value_rus'] = URL.createObjectURL(this.href)
          this.hrefData['value_eng'] = URL.createObjectURL(this.href)
          this.hrefData['file'] = URL.createObjectURL(this.href)
        } else {
          this.hrefData['value_rus'] = this.href
          this.hrefData['value_eng'] = this.href
        }
      }
      if (this.hrefData['file']) { return this.hrefData['file'] }
      if (this.$i18n.locale == 'ru') { return this.hrefData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.hrefData['value_eng'] }
    },
    contentComputed () {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.contentData['value_rus'] = this.content }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.contentData['value_eng'] = this.content }
      if (this.$i18n.locale == 'ru') { return this.contentData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.contentData['value_eng'] }
    },
    isAuth () {
      return this.$store.getters['adminAuth/checkAuth']
    },
    show () {
      if ( (!this.checkContent) || this.deleted ) {
        return false
      }
      return true
    }
  }
}
</script>
